import { parseTime } from '@/common/index'
// 公共方法

export default {
  isVal(val) {
    if (val || val === 0) {
      return val
    } else {
      return '--'
    }
  },
  timeFormat(value, format = 'YYYY-MM-DD HH:mm:ss') {
    if (!value) return '/'
    return moment(value).format(format);
  },
  // 时间戳
  timestampDate(value, type) {
    if (value) {
      var date = new Date(Number(value)) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear()
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
      var D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
      if (type == 'yyyy-MM') {
        return Y + '-' + M
      }
      return Y + '-' + M + '-' + D
    }
  },
  //开票情况
  cusOpenStatusFliter(value) {
    if (value) {
      if (value == "1") {
        return "代开";
      } else if (value == "2") {
        return "需要领票";
      } else if (value == "2") {
        return "不领发票";
      }
    } else {
      return '--'
    }
  },

  // 时间戳
  timestamsecond(value) {
    if (value) {
      var date = new Date(Number(value)) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-'
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      var D = date.getDate() + ' '
      var h = date.getHours() + ':'
      var m = date.getMinutes() + ':'
      var s = date.getSeconds()
      return Y + M + D + h + m + s
    }
  },

  // 企业类型
  companyFilters(val) {
    if (val == '0') {
      return '全部'
    } else if (val == '1') {
      return '有限责任公司'
    } else if (val == '2') {
      return '股份公司'
    } else if (val == '3') {
      return '集团公司'
    } else if (val == '4') {
      return '有限合伙企业'
    } else if (val == '5') {
      return '普通合伙企业'
    } else if (val == '6') {
      return '个人独资企业'
    }
  },


  // 时间戳
  timestampToTime(val) {
    if (val) {
      var date = new Date(val); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      var h =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var m =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      var s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    } else {
      return '/'
    }
  },
  //图片地址
  imgFilter(val) {
    var url = location.origin
    if (val) {
      let index = val.lastIndexOf('/')
      var valid = val.substring(index)
      if (url.includes("cn")) {
        return 'https://jbbcs.hzjbqy.cn/jbbcs/file/getUploadFile/' + valid + '?token=' + window.localStorage.getItem('token')
      } else {
        return "https://jbbcs.hzjbqy.com/jbbcs/file/getUploadFile/" + valid + '?token=' + window.localStorage.getItem('token')
      }
    } else {
      return 'static/img/zanwu3.png'
    }
  },
  //图片地址3
  filePathFilter(val) {
    if (val) {
      var val = val.split('/');
      var valNum = val.length;
      var valid;
      for (var i = 0; i < valNum; i++) {
        valid = val[valNum - 1]
      }
      return 'https://jbbcs.hzjbqy.cn/justarsFile/' + valid + '?token=' + window.localStorage.getItem('token')
    } else {
      return 'static/img/zanwu.png'
    }
  },
  //图片路径过滤器
  filePathFilter2(val) {
    if (val) {
      var val = val.split('/');
      var valNum = val.length;
      var valid;
      for (var i = 0; i < valNum; i++) {
        valid = val[valNum - 1]
      }
      return 'https://jbbcs.hzjbqy.cn/justarsFile/' + valid + '?token=' + window.localStorage.getItem('token')
    } else {
      return 'static/img/zanwu2.png'
    }
  },


  //产品类型
  productType(val) {
    if (val == '0') {
      return "产品"
    } else if (val == '1') {
      return "套餐"
    }
  },
  //纳税人资格
  natureFilter(val) {
    if (val == "0,2") {
      return "一般纳税人/零申报"
    } else if (val == "1,2") {
      return "小规模纳税人/零申报"
    } else if (val == "0,3") {
      return "一般纳税人/非零申报"
    } else if (val == "1,3") {
      return "小规模纳税人/非零申报"
    }
  },
  //支付方式
  // paymentWayFilter(val){
  //     if(val=="1"){
  //     return "腾讯平台"
  //     }else if(val=="2"){
  //         return "支付宝"
  //     }else if(val=='3'){
  //         return "财付通"
  //     }else if(val=="4"){
  //         return "微信"
  //     }else if(val=='5'){
  //         return "私账 "
  //     }else if(val=="6"){
  //         return "公账"
  //     }else if(val=="7"){
  //         return "刷卡"
  //     }else if(val=="8"){
  //         return "现金"
  //     }
  // },


  paymentWayFilter(val) {
    if (val == "1") {
      return "微信"
    } else if (val == "2") {
      return "支付宝"
    } else if (val == '5') {
      return "企业支付宝"
    } else if (val == "6") {
      return "对公"
    } else if (val == "7") {
      return "联合银行(黄功成)"
    } else if (val == "8") {
      return "联合银行(孙玉芝)"
    } else if (val == "9") {
      return "淘宝(济邦邦)"
    } else if (val == "10") {
      return "工商银行(对公银行)"
    } else if (val == "11") {
      return "企业微信"
    } else if (val == "12") {
      return "农业银行(爱华对公)"
    } else if (val == "13") {
      return "支付宝(爱华)"
    } else if (val == "14") {
      return "权驿站微信"
    } else if (val == "15") {
      return "权驿站支付宝"
    } else if (val == "16") {
      return "工商银行(权驿站对公)"
    } else if (val == "19") {
      return "正潮（工行对公）"
    } else if (val == "20") {
      return "爱华微信"
    } else if (val == "21") {
      return "权驿站企业微信"
    } else if (val == "22") {
      return "权驿站支付宝"
    } else if (val == "23") {
      return "爱华支付宝"
    }else if (val == "24") {
      return "现金"
    }
  },
  //价格单位
  priceFilter(val) {
    if (val || val == 0) {
      if (val == 0) {
        return val
      } else {
        let numVal = Number(val);
        if (numVal > 10000 || numVal < -10000) {
          numVal = numVal * 10000;
          return (numVal / 100000000).toFixed(2) + "万";
        } else {
          return numVal + "元";
        }
      }
    } else {
      return "--";
    }
  },

  //量化指标单位
  unitFilter(val) {
    if (val) {
      if (val == '1') {
        return '%';
      } else if (val == '2') {
        return '个';
      } else if (val == '3') {
        return '万';
      } else if (val == '4') {
        return '家';
      } else if (val == '5') {
        return '人';
      } else if (val == '6') {
        return '件';
      } else if (val == '20') {
        return '-';
      } else {
        return val;
      }
    } else {
      return "-";
    }
  },


  //地址是否异常
  isExceptionFilter(val) {
    return val == '1' ? "是" : "否"
  },
  //可否领票
  takeTicketFilter(val) {
    return val == '1' ? '可以' : (val == '2' ? '不能' : '');
  },
  //使用状态
  usagesFilter(val) {
    return val === '1' ? '未使用' : (val === '2' ? '已使用' : (val === '3' ? '需警示' : (val === '4' ? '已冻结' : '')));
  },
  //结算状态
  isSettleFilter(val) {
    return val === '1' ? '已结算' : (val === '2' ? '未结算' : (val === '3' ? '结算中' : '--'));
  },
  //异常类型
  exceptionStatusFilter(val) {
    return val === '1' ? '服务中' : (val === '2' ? '已过期' : (val === '3' ? '异常' : ''));
  },
  addressFilter(val) {
    if (val == '1') return '未使用';
    if (val == '2') return '已使用';
    if (val == '3') return '需警示';
    if (val == '4') return '已冻结';
    if (val == '5') return '审批中';
    if (val == '6') return '已审批';
    if (!val || val == null) return '无异常';
  },
  //异常类型
  eStatusFilter(val) {
    if (val == '1') return '地址异常';
    if (val == '2') return '其他异常';
    if (val == '3') return '工商异常';
    if (val == '4') return '税务异常';
    if (!val || val == null) return '无异常';
  },
  //解除异常情况
  exceptionsFilter(val) {
    if (val == '1') {
      return '可以'
    } else if (val == '2') {
      return '不可以'
    } else if (val == '3') {
      return '可以（+2000）'
    } else if (val == '4') {
      return '可以（+3500）'
    }
  },
  // 审核状态过滤  组织机构 短信设置
  mobanStatusFilter(val) {
    return val === '0' ? '已通过' : (val === '1' ? '待审核' : (val === '2' ? '审核不通过' : ''));
  },
  //服务续费提醒
  renewFilter(val) {
    return val === '0' ? '提醒' : (val === '1' ? '不提醒' : '');
  },
  //产品供应商类型
  remarkFilter(val) {
    return val === '0' ? '自营' : (val === '1' ? '供应商' : '');
  },
  //员工列表性别
  sexFilter(val) {
    return val === '0' ? '女' : (val === '1' ? '男' : '');
  },
  //员工列表是否参与排行榜
  isPxbFilter(val) {
    return val === '0' ? '不参与' : (val === '1' ? '参与' : '');
  },
  //员工列表是否参与了折扣
  isZhekouFilter(val) {
    return val === '0' ? '不参与' : (val === '1' ? '参与' : '');
  },
  //反馈状态
  backlogStatusFilter(val) {
    return val === '1' ? '待处理' : (val === '2' ? '已处理' : '');
  },
  //反馈类型
  remarkStatusFilter(val) {
    if (val == '0') {
      return "快递单号"
    } else if (val == "1") {
      return "备注"
    } else if (val == "2") {
      return "确认结果"
    }
  },
  //是否显示给客户
  isShowFilter(val) {
    return val === '0' ? '是' : (val === '1' ? '否' : '');
  },
  workStautsFilter(val) {
    if (val == "0") {
      return "已完成"
    } else if (val == "1") {
      return "进行中"
    } else if (val == "2") {
      return "审核中"
    } else if (val == "3") {
      return "审核未通过"
    } else if (val == "4") {
      return "地址审核"
    } else if (val == "5") {
      return "地址审核中"
    } else if (val == "6") {
      return "审核通过"
    } else if (val == "8") {
      return "交接单待填写"
    } else if (val == "9") {
      return "交接单已填写"
    }
  },
  //记账费是否已付
  acountStausFliter(val) {
    return val === '1' ? '是' : (val === '2' ? '否' : '');
  },
  //网站栏目中  状态
  questionStatusFilter(val) {
    if (val == "0") {
      return "审核通过"
    } else if (val == "1") {
      return "待审核"
    } else if (val == "2") {
      return "审核失败"
    }
  },
  //网站栏目中 状态
  enableFilter(val) {
    if (val == "0") {
      return "启用"
    } else if (val == "1") {
      return "未启用"
    }
  },
  //回复人类型
  answererTypeFilter(val) {
    if (val == "0") {
      return "用户"
    } else if (val == "1") {
      return "工商会计"
    }
  },

  //产品是否续费 ndd
  isRenewFilter(val) {
    return val === '0' ? '否' : (val === '1' ? '是' : '');
  },
  //订单状态 ndd
  businessStatusFilter(val) {
    if (val == '1') {
      return "待审核"
    } else if (val == "2") {
      return "进行中"
    } else if (val == "3") {
      return "已完成"
    }
  },

  //金额大写
  priceDaXie(n) {
    var fraction = ['角', '分'];
    var digit = [
      '零', '壹', '贰', '叁', '肆',
      '伍', '陆', '柒', '捌', '玖'
    ];
    var unit = [
      ['元', '万', '亿'],
      ['', '拾', '佰', '仟']
    ];
    var head = n < 0 ? '欠' : '';
    n = Math.abs(n);
    var s = '';
    for (var i = 0; i < fraction.length; i++) {
      s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');
    }
    s = s || '整';
    n = Math.floor(n);
    for (var i = 0; i < unit[0].length && n > 0; i++) {
      var p = '';
      for (var j = 0; j < unit[1].length && n > 0; j++) {
        p = digit[n % 10] + unit[1][j] + p;
        n = Math.floor(n / 10);
      }
      s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
    }
    return head + s.replace(/(零.)*零元/, '元')
      .replace(/(零.)+/g, '零')
      .replace(/^整$/, '零元整');
  },

  //停用原因过滤器
  stopResonFilter(val) {
    if (val == "1") {
      return "济邦邦注销"
    } else if (val == "2") {
      return "客户自行注销"
    } else if (val == "3") {
      return "聘请专职会计"
    } else if (val == "4") {
      return "移走到其它财务公司"
    } else if (val == "5") {
      return "转让"
    } else if (val == "6") {
      return "失联"
    } else if (val == "7") {
      return "无法有效沟通"
    } else if (val == "9") {
      return "自己或朋友做账"
    } else if (val == "8") {
      return "其它原因推迟支付"
    } else {
      return val
    }
  },

  /**
   * 转化年月时间
   * @param {Number} value 时间戳
   * @returns 年月时间
   */
  ymTimeFilter(value) {
    return parseTime(value, '{y}-{m}')
  },

  /**
   * 转化年月日时间
   * @param {Number} value 时间戳
   * @returns 年月日时间
   */
  ymdTimeFilter(value) {
    return parseTime(value, '{y}-{m}-{d}')
  },

  /**
   * 转化年时月日时间
   * @param {Number} value 时间戳
   * @returns 年月日时时间
   */
  ymdhTimeFilter(value) {
    return parseTime(value, '{y}-{m}-{d} {h}')
  },

  /**
   * 转化年月日时分时间
   * @param {Number} value 时间戳
   * @returns 年月日时分时间
   */
  ymdhiTimeFilter(value) {
    return parseTime(value, '{y}-{m}-{d} {h}:{i}')
  },

  /**
   * 转化年月日时分秒时间
   * @param {Number} value 时间戳
   * @returns 年月日时分秒时间
   */
  ymdhisTimeFilter(value) {
    return parseTime(value)
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/common/globalFilter.js